<template lang="">
  <PageComponents>
    <template>
    <div>

      <div class="container">
        <div class="row" style="margin-bottom:50px">
          <div class="col">
            <h3 class="float-lg-none tc-4241 mt-lg-0 mb-lg-4 h3-bloc-8-style text-lg-center"><span
                class="fa fa-laptop"></span>&nbsp; &nbsp;Xhorse Technology Development Software Download</h3>
            <div class="row g-0 pt-lg-5 custom-container">
              <div class="col-lg-6 custom">
                <picture>
                  <img class="img-fluid mx-auto d-block img-9-style mg-md lazyloaded" :src="mvci" width="200" height="200">
                </picture>
                <h3 class="mb-4 h3-style text-lg-center mb-lg-2 tc-2340 mx-auto d-block"><span
                    class="fab fa-app-store"></span>&nbsp;MVCI PRO-J2534<br></h3>
                <p class="text-lg-center tc-2340">Replace the original factory inspection equipment to complete the
                  vehicle diagnosis, programming and other functions.<br></p>
                <div class="text-center"><a href="" ref="mvcipro" target="_blank" class="btn btn-lg btn-style btn-c-4241">Download</a></div>
              </div>
              <div class="col offset-lg-0 custom">
                <picture>
                  <img class="img-fluid mx-auto d-block img-9-style mg-md lazyloaded" :src="prog" width="200" height="200">
                </picture>
                <h3 class="mb-4 h3-bloc-9-style mx-auto d-block text-lg-center mb-lg-2 tc-2340"><span
                    class="fab fa-app-store"></span>&nbsp;VVDI PROG</h3>
                <p class="text-lg-center tc-2340">Support read & write various MCU and EEPROM chips, read & write immo
                  modules, read & write Encrypted chips, read & write ECU without opening, etc.</p>
                <div class="text-center"><a href="" ref="vvdipro" class="btn btn-lg btn-style btn-c-4241">Download<br></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top:150px">
          <div class="col">
            <div class="alert bgc-4241 alert-warning" role="alert">
              <p class="mb-0">If you have any advice or need any help, we will try our best to serve you. &nbsp; -
                Customer Service: 400-777-8776 &nbsp; &nbsp; - Email: support@xhorse.com<br></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
  </PageComponents>
</template>
<script>
import PageComponents from "@/components/page-components";
import mvci from "@/assets/css/img/mvci.png";
import prog from "@/assets/css/img/prog.png";
export default {
  components: {
    PageComponents
  },
  data: () => ({
    mvci,
    prog,
    activeIndex: {
      side: [],
      top: []
    }
  }),
  mounted() {
    const mvcipro = this.$refs.mvcipro;
    const vvdipro = this.$refs.vvdipro;

    // 国外下载地址
    if (location.href.includes(".com")) {
      mvcipro.href = "http://dl.xhorse.com/product/mvci/MVCI_PRO-J2534.exe";
      vvdipro.href = "https://mega.nz/file/1YFD2CiS#kaUNSX5gX7dMuJVxdjFBFrd5LEaf9Xl9aKEQm5o8nTw";
      return;
    }
    mvcipro.href = "http://dl.xhorse.net.cn/product/mvci/MVCI_PRO-J2534.exe";
    vvdipro.href = "https://share.weiyun.com/bDAM7gew";
  },
  beforeRouteLeave(to, from, next) {
    //console.log("template[about]", to, from)
    const _this = this;
    var data = {
      side: _this.activeIndex.side,
      top: _this.activeIndex.top
    };

    if (
      to.params.hasOwnProperty("activeTop") &&
      to.params.hasOwnProperty("activeSide")
    ) {
      data.side = to.params.activeSide;
      data.top = to.params.activeTop;
    }

    _this.$store.commit("setActivePath", {
      type: "all",
      val: data
    });
    window.removeEventListener("scroll", _this.onAboutScroll, false);
    next(true);
  }
};
</script>
<style scope>
@import "../../../assets/css/all/all.min.css";
@import "../../../assets/css/all/animate.min.css";
@import "../../../assets/css/all/style.css";
@import "../../../assets/css/all/bootstrap.min.css";
.container {
  text-align: left;
  margin-top: 100px;
}

.btn-c-4241.btn-c-4241.btn-c-4241.btn-c-4241.btn-c-4241.btn-c-4241 {
  background: #f37303;
  color: #fff !important;
}
.custom-container{
  justify-content: space-around;

}
.custom.custom.custom.custom{
  max-width: 45%;
}

</style>





// WEBPACK FOOTER //
// src/components/zh-cn/download/index.vue